/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import asm from 'assembly/Asm';
import {Sequence as BioJSSequence} from 'BioJS';
import {Sequence} from 'components/Sequence';
import * as AssemblyConstants from 'constants/AssemblyConstants';
const {ASSEMBLY_TYPE} = AssemblyConstants;
import {Strand} from 'constants/MolbioConstants';
import {Collection, RegionSelectable, SelectableAttributes} from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';

export class GoldenGateCutSite extends RegionSelectable<Sequence> {
  defaults(): Partial<SelectableAttributes> {
    return {
      // @ts-expect-error This function incorrectly returns an object that differs from the
      // `Selectable.defaults` signature
      start: null,
      end: null,
      cutSiteOffset: null,
    };
  }

  start(): number {
    return this.get('start');
  }

  end(): number {
    return this.get('end');
  }

  cutSiteOffset(): number | null {
    return this.get('cutSiteOffset');
  }

  uid(): string {
    return this.cid;
  }

  strand(): Strand {
    return 0;
  }

  click(sequence: Sequence): void {
    sequence.selection().select(this);
  }
}

class GoldenGateCutSites extends Collection<GoldenGateCutSite> {
  static initClass(): void {
    this.prototype.model = GoldenGateCutSite;
  }

  slice(start: number, end: number): Array<GoldenGateCutSite> {
    return this.filter((cutSite) => sequtil.isRangeOverlap(start, end, cutSite.start(), cutSite.end()));
  }

  updateCutSites(_sequence: BioJSSequence): void {
    if (_sequence.finalized() || _sequence.assemblyType() !== ASSEMBLY_TYPE.GOLDEN_GATE) {
      this.reset([]);
      return;
    }
    // Find all cutSites.
    const stickyEndRanges = asm.goldenGate.stickyEndRanges(_sequence);
    const enzyme = _sequence.assembly()!.enzyme();
    const cutSiteOffset = enzyme.get('offset');
    const cutSites = stickyEndRanges.map(({start, end}) => ({start, end, cutSiteOffset}));
    // @ts-expect-error `reset` expects Backbone models, and we're giving it the models' attributes instead
    this.reset(cutSites);
  }
}
GoldenGateCutSites.initClass();

export default GoldenGateCutSites;
